import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Intercom from 'react-intercom';

const useStyles = makeStyles(theme => ({
    appTopBar: {
        top: 0,
        bottom: 'auto',
    },
    grow: {
        flexGrow: 1,
    },
    labelOne: {
        fontSize: 40,
        fontWeight: 'bold',
        fontFamily: 'effra',
        color: '#1A237A',
    },
    labelTwo: {
        fontSize: 24,
        fontWeight: 'regular',
        fontFamily: 'effra',
        color: '#69737A',
    },
    align: {
        textAlign: 'center',
    },
    btnPattern: {
        width: '274px',
        height: '48px',
    }
}));

const ErrorScreen = () => {

    const classes = useStyles();


    const user = {
        user_id: '',
        email: '',
        name: ''
      };

    return (
        <Grid container>
            <img src={require('./../assets/Contele-Fleet-Tracking.png')} alt="" className="topLogoImage" />
            <AppBar position="fixed" color="inherit" className={classes.appTopBar}>
                <Toolbar>
                    <div className={classes.grow} />
                </Toolbar>
            </AppBar>
            <Grid item xs={12}  className={classes.align}>
            <img src={require('./../assets/error-image.png')} alt="" />
            </Grid>
            <Grid item xs={12}  className={classes.align} style={{paddingBottom: '8px',}}>
                <label className={classes.labelOne}>Oh no! Something went wrong.</label>
            </Grid>
            <Grid item xs={12}  className={classes.align} style={{paddingTop: '8px',}}>
                <label className={classes.labelTwo}>Try again or contact our support team.</label>
            </Grid>
            <Grid item xs={12}  className={classes.align} style={{paddingTop: '32px', paddingBottom: '8px'}}>
                    <Button variant="contained" color="primary" className={useStyles.button} style={{width: '274px',height: '48px',}} onClick={() => window.location.href = `${window.location.protocol}//${window.location.hostname}`}>
                        Try Again
                    </Button>
            </Grid>
            <Grid item xs={12}  className={classes.align} style={{paddingTop: '8px'}}>
                <Button variant="outlined" color="primary" className={useStyles.button} style={{width: '274px',height: '48px',}}>
                        Support
                    <Intercom appID="e62w2d7x" />
                </Button>
            </Grid>
        </Grid>
    );
};

export default ErrorScreen;